module.exports = __webpack_public_path__ + "static/media/customer.7de18223.svg";